import { useRef, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Plus, X, UploadSimple } from "@phosphor-icons/react";
import { toast } from "sonner";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function toDisplayUrl(pathOrUrl) {
  if (!pathOrUrl) return "";
  if (pathOrUrl.startsWith("http")) return pathOrUrl;
  // stored as /api/files/... or raw storage path
  const p = pathOrUrl.startsWith("/api/") ? pathOrUrl : `/api/files/${pathOrUrl}`;
  return `${BACKEND}${p}`;
}

export default function PhotoUpload({ photos, onChange, testId = "photo-upload" }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFiles = async (files) => {
    if (!files || !files.length) return;
    setUploading(true);
    const uploaded = [];
    for (const f of Array.from(files)) {
      const form = new FormData();
      form.append("file", f);
      try {
        const { data } = await api.post("/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
        uploaded.push(data.url);
      } catch (e) {
        toast.error(formatApiError(e));
      }
    }
    setUploading(false);
    if (uploaded.length) onChange([...(photos || []), ...uploaded]);
  };

  const remove = (i) => {
    const next = [...photos];
    next.splice(i, 1);
    onChange(next);
  };

  return (
    <div>
      <div className="grid grid-cols-3 gap-2 mb-2">
        {(photos || []).map((p, i) => (
          <div key={i} className="relative aspect-[4/3] border border-neutral-200 overflow-hidden group">
            <img src={toDisplayUrl(p)} alt="" className="w-full h-full object-cover"/>
            <button
              type="button"
              data-testid={`remove-photo-${i}`}
              onClick={() => remove(i)}
              className="absolute top-1 right-1 w-6 h-6 bg-white/90 hover:bg-white border border-neutral-300 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <X size={12}/>
            </button>
          </div>
        ))}
        <button
          type="button"
          data-testid={testId}
          onClick={() => inputRef.current?.click()}
          className="aspect-[4/3] border border-dashed border-neutral-300 hover:border-neutral-900 flex flex-col items-center justify-center text-neutral-500 hover:text-neutral-900 transition-colors"
        >
          {uploading ? <UploadSimple size={20} className="animate-pulse"/> : <><Plus size={20}/><span className="text-xs mt-1">Add photo</span></>}
        </button>
      </div>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        multiple
        className="hidden"
        onChange={(e) => handleFiles(e.target.files)}
      />
      <div className="text-xs text-neutral-500">JPG, PNG or WEBP · up to 8 MB each</div>
    </div>
  );
}
